import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { Link } from '@mui/material';
import React from 'react';
import { BooleanParam, useQueryParam } from 'use-query-params';

import { buildOrganizationManifestState } from 'components/StudyDashboard/CaseManifest/organizationEntry';
import { getDatasetMode } from 'components/StudyDashboard/ProceduresPage/datasetMode';
import { Permission } from 'interfaces/permissionOption';
import { CompressedJsonParam } from 'utils/customQueryParamsConfigs';
import { useCurrentLabId } from 'utils/useCurrentLab';
import { useEncodedFilters } from 'utils/useEncodedFilters';
import { usePermissions } from 'utils/usePermissions';
import UploadStepInfoCard from './UploadStepInfoCard';

const StudyCohortManifestModalLinkStep = () => {
  const { hasPermission } = usePermissions();
  const { labId } = useCurrentLabId();
  const { queryParams } = useEncodedFilters();
  const [, setIsManifestDialogOpen] = useQueryParam('isManifestDialogOpen', BooleanParam);
  const [, setSlidesMode] = useQueryParam('slidesMode', BooleanParam);
  const [pendingSlidesMode] = useQueryParam('pendingSlidesMode', BooleanParam);
  const [, setManifestDialogUrlState] = useQueryParam('caseManifestState', CompressedJsonParam);

  if (!hasPermission(Permission.ApplyCaseManifest)) {
    return null;
  }

  const openManifestDialog = () => {
    setManifestDialogUrlState(
      buildOrganizationManifestState({
        mode: 'advanced',
        returnTo: {
          origin: 'dataset',
          labId,
          studyId: String(queryParams.filters?.studyId),
          datasetMode: getDatasetMode({ slidesMode: queryParams.slidesMode, pendingSlidesMode }),
          page: queryParams.page,
          searchTerm: queryParams.searchTerm || undefined,
        },
      }),
      'replaceIn'
    );
    setIsManifestDialogOpen(true, 'replaceIn');
    setSlidesMode(true, 'replaceIn');
  };

  return (
    <UploadStepInfoCard
      icon={<AssignmentOutlinedIcon color="secondary" fontSize="small" />}
      tone="manifest"
      title="Organize cases and slides"
      description="Open the slides manifest to assign uploaded slides to cases and prepare case and slide metadata for this study."
    >
      <Link component="button" type="button" variant="body2" underline="hover" onClick={openManifestDialog}>
        Organize slides
      </Link>
    </UploadStepInfoCard>
  );
};

export default StudyCohortManifestModalLinkStep;
